// extracted by mini-css-extract-plugin
export default {"staticMap_Embed":"static-map--staticMap_Embed","staticMap":"static-map--staticMap"};